export const toastOptions = {
  success: {
    iconTheme: {
      primary: 'white',
      secondary: 'green',
    },
    style: {
      background: 'green',
      color: 'white',
    },
  },
  error: {
    iconTheme: {
      primary: 'white',
      secondary: 'red',
    },
    style: {
      background: 'red',
      color: 'white',
    },
  },
};
